
// State Object for LabelsCatalog. Dont directly mutate it anywhere except the labels/mutations.js file
export const labelsCatalogState = {
  labelsCatalogData: null,
  labelList: null,
  label_list_start_from: 0,
  labelDetails: null,
}


